import RNnotifee, {
  AndroidImportance,
  Event,
  EventType,
} from '@notifee/react-native';

import {FirebaseMessagingTypes} from '@react-native-firebase/messaging';
import {OnBoardingScreens} from '../../onBoarding/navigation/types';
import {navigation} from '../navigation';
import {notification} from '.';

export class Notifee {
  notifeeForegroundRef!: () => void;

  setForegroundEvent() {
    this.notifeeForegroundRef = RNnotifee.onForegroundEvent(
      this.onNotificationEvent.bind(this),
    );
  }

  unsubscribeForegroundEvent() {
    this.notifeeForegroundRef();
  }

  async createChannel() {
    return await RNnotifee.createChannel({
      id: 'important',
      name: 'Important Notifications',
      importance: AndroidImportance.HIGH,
    });
  }

  cancelNotification(id: string) {
    RNnotifee.cancelNotification(id);
  }

  async showNotification(title: string, body: string, id?: string) {
    const channelId = await this.createChannel();
    RNnotifee.displayNotification({
      title: title,
      body: body,
      id,
      android: {
        smallIcon: 'buncha_icon',
        channelId,
        color: '#ffde7d',
        pressAction: {
          id: 'default',
        },
        importance: AndroidImportance.HIGH,
      },
      ios: {
        attachments: [{url: 'buncha_round'}],
      },
    });
  }

  async displayNotification(message: FirebaseMessagingTypes.RemoteMessage) {
    const channelId = await this.createChannel();
    RNnotifee.displayNotification({
      title: message.notification?.title,
      body: message.notification?.body,
      android: {
        smallIcon: 'buncha_icon',
        channelId,
        color: '#ffde7d',
        pressAction: {
          id: 'default',
        },
        importance: AndroidImportance.HIGH,
      },
      ios: {
        attachments: [{url: 'buncha_round'}],
      },
      data: message.data as any,
    });
  }

  onNotificationEvent(event: Event) {
    if (event.type === EventType.PRESS) {
      if (!event.detail.notification?.data) return;
      const remoteMessage = event.detail.notification;
      if (!Object.keys(remoteMessage).length) return;
      notification.onNotificationOpen(
        remoteMessage,
        navigation.getCurrenRouteName() !== OnBoardingScreens.Splash,
      );
    }
  }

  async getInitialNotification() {
    return await RNnotifee.getInitialNotification();
  }

  async onBackgroundEvent(_event: Event) {
    // Comment added for soran fixes
  }
}

export const notifee = new Notifee();
